// Contratos compartilhados da vitrine/bio (storefront publico do afiliado).
// Reusados pelo Worker SSR (apps/storefront) e pelo painel (apps/panel) para
// evitar drift de contrato entre as camadas.
/** Slugs reservados, bloqueados na normalizacao e no servidor. */
export const RESERVED_STOREFRONT_SLUGS = [
    "app",
    "api",
    "login",
    "cadastro",
    "privacidade",
    "r",
    "loja",
    "admin",
    "www",
];
/** Layouts validos da vitrine, fonte unica para validacao na borda. */
export const STOREFRONT_LAYOUTS = ["grid", "bio"];
/** Layout padrao quando branding nao define um. */
export const DEFAULT_STOREFRONT_LAYOUT = "grid";
/** Cor de destaque padrao quando branding nao define uma. */
export const DEFAULT_STOREFRONT_ACCENT = "#1F8A4C";
//# sourceMappingURL=storefront.js.map